/*
一次充电成功率
 */
import React, { Component } from "react";
import "@/assets/stylus/data_analysis.styl";
import PropTypes from "prop-types";
import "@ant-design/compatible/assets/index.css";
import { Affix } from "antd";
import FormCore from "@/components/display/form/formCore";
import CityDataFilterHoc from "@/hoc/form/cityDataHoc";
import { connect } from "react-redux";
import { injectIntl } from "react-intl";
import moment from "moment";
import ChargeSuccessDay from "./chargeSuccessDay";
import StopReason from "./stopReason";
import { getEquSuccessRate, getStationOrEquStopReason } from "../../../fetch/fetchApi";
import fetchHandler from "../../../fetch/fetchHandler";
import "./index.styl";

@CityDataFilterHoc
@connect((state) => state)
class EquChargeDetail extends Component {
  static contextTypes = {
    store: PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.props = props;
    this.internationalization = this.props.intl.messages.chargSuccess;

    this.props = props;
    this.state = {
      formConfig: null,
      monthDataList: [], // 按月呈现数据源
      dailyDataList: [], // 按日呈现数据源
      stopReasonDataList: [], // 停止原因数据源
      title: window.LayoutTab.tabParam.equipmentInfo.stubId,
      params: {
        successType: "1",
        startTime: moment().subtract(7, "d").format("YYYYMMDD"),
        endTime: moment().format("YYYYMMDD"),
        stubId: window.LayoutTab.tabParam.equipmentInfo.stubId,
      },
    };
  }

  componentWillMount() {
    this.setState({
      formConfig: this.initFormConfig(),
    });

    this.initSource();
  }

  initFormConfig() {
    this.setState({
      isSearch: 1,
    });

    const formConfig = {
      childItems: [
        {
          type: "select",
          options: [
            {
              text: "充电成功率", // '交流',
              value: "1",
            },
            {
              text: "启动成功率", // '直流',
              value: "0",
            },
          ],
          placeholder: "请选择设备类型",
          param: {
            name: "successType",
            type: "string",
          },
          labelName: "类型", // '成功率类型:',
          required: false,
          defaultValue: "1",
        },

        {
          type: "buttonGp", // 表单最终执行组
          buttonArr: [
            {
              btnType: "button",
              // icon: 'search',
              text: this.internationalization.btn1, // '查询',
              handler: (e, param) => {
                this.setState(
                  {
                    params: {
                      ...this.state.params,
                      ...param,
                    },
                  },
                  () => {
                    this.initSource();
                  },
                );
              },
            },
          ],
        },
      ],
      layout: "inline", // 设置布局 0： 横向布局， 1：纵向布局
      formTarget: "grid", // 表单提交类型，设置grid则为更新grid
      autoLoadGrid: !1, // 设置为false不触发加载grid
      context: this,
      tableKey: "taskTable",
    };

    return formConfig;
  }

  initSource = () => {
    this.handleGetDailyData();
    this.handleGetStopReasonData();
  };

  // 获取日数据
  handleGetDailyData = () => {
    this.setState({
      dayLoading: true,
    });
    fetchHandler(getEquSuccessRate, {
      ...this.state.params,
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          dailyDataList: res.data,
        });
      }
      this.setState({
        dayLoading: false,
      });
    });
  };

  // 获取停止原因数据源
  handleGetStopReasonData = () => {
    this.setState({
      stopReasonLoading: true,
    });
    fetchHandler(getStationOrEquStopReason, {
      ...this.state.params,
      isStubGroup: 0,
    }).then((res) => {
      if (res && res.code === "success") {
        this.setState({
          stopReasonDataList: res.data,
        });
      }
      this.setState({
        stopReasonLoading: false,
      });
    });
  };

  render() {
    const name = this.state.params.successType === "1" ? "充电成功率" : "启动成功率";
    const val = (
      <div
        className='analysis charge-success-rate-container'
        ref='chargSuccsessRate'
        style={{ height: "100%", overflowY: "auto", overflowX: "hidden" }}>
        <Affix target={() => this.refs.chargSuccsessRate}>
          <div className='analysis-title'>
            <FormCore formConfig={this.state.formConfig} />
          </div>
        </Affix>

        {/* <div className="analysis-item">
          <div className="analysis-item-title analysis-title-font">
            {this.state.title}
          </div>
        </div> */}
        <ChargeSuccessDay
          {...this.props}
          dataSource={this.state.dailyDataList}
          setChooseDate={() => {}}
          chooseDate={moment()}
          title={`设备${this.state.title} 近7天${name}`}
          chartId='equ-charge-success-day-chart'
          loading={this.state.dayLoading}
        />

        <StopReason
          {...this.props}
          title={`设备${this.state.title} 近7天订单停止原因`}
          dataSource={this.state.stopReasonDataList}
          chartId={["equ-stop-reason-chart1", "equ-stop-reason-chart2"]}
          loading={this.state.stopReasonLoading}
        />
      </div>
    );
    return val;
  }
}

export default injectIntl(EquChargeDetail);



// WEBPACK FOOTER //
// ./src/AntD/pages/indicatorReport/chargeSuccessRate/equChargeDetail.js